@if (loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!loading && !access) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    @if (!no_plan) {
      <div class="text-center">
        <h1 class="text-warning">You do not have permission!</h1>
        <p class="text-muted">please contact revealense administration for getting access to our API.</p>
      </div>
    }
    @if (no_plan) {
      <div class="text-center">
        <h1 class="text-warning">No Subscription Found!</h1>
        <p class="text-muted">You must have an active subscription to see this page.</p>
      </div>
    }
  </div>
}


@if (access && !apiKey && !loading) {
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center mt-sm-5 pt-4">
          <div class="mb-5 text-white-50">
            <p class="fs-14">API Key not created yet.</p>
            <div class="mt-4 pt-2">
              <a class="btn btn-success" (click)="openCreateKeyModal()">
                <i class="ri-add-line align-bottom me-1"></i>Create API Key</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (access && apiKey && !loading) {
    <div class="row">
      <div class="col-12">
        <label for="api-key" class="form-label">API Key</label>
        <div class="input-group w-25">
          <input type="password" class="form-control" [value]="key" id="api-key" readonly>
          <button class="btn btn-success shadow-none ri-refresh-line" ngbTooltip="Regenerate Key" (click)="openCreateKeyModal()" type="button"></button>
        </div>
        <p class="text-warning mt-2">** API key is only view once when created, if you can not find your api key regenerate a new key.</p>
      </div>
      <div class="col-lg-4">
        <div class="card card-animate card-height-100">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div>
                <p class="fw-medium text-muted mb-0">Monthly requests</p>
                <h2 class="mt-4 ff-secondary fw-bold">
                  <span [countUp]="success_calls + failed_calls" class="counter-value" [options]="option"></span>
                </h2>
                <p class="mb-0 text-muted">
                  <span class="badge bg-light mb-0" [ngClass]="percentageChange_month >= 0 ? 'text-success' : 'text-danger'">
                    <i class="align-middle" [ngClass]="percentageChange_month >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'"></i> {{ percentageChange_month }}% </span> {{ success_calls + failed_calls }} last month
                  </p>
                </div>
                <div>
                  <div class="avatar-sm flex-shrink-0">
                    <span class="avatar-title bg-success-subtle rounded-circle fs-2">
                      <i class="ri-exchange-line text-secondary"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card card-animate card-height-100">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="fw-medium text-muted mb-0">Successful requests</p>
                  <h2 class="mt-4 ff-secondary fw-bold">
                    <span [countUp]="success_calls" class="counter-value" [options]="option"></span>
                  </h2>
                  <p class="mb-0 text-muted">
                    <span class="badge bg-light mb-0" [ngClass]="percentageChange_success_calls >= 0 ? 'text-success' : 'text-danger'">
                      <i class="align-middle" [ngClass]="percentageChange_success_calls >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'"></i> {{ percentageChange_success_calls }}% </span> {{ prev_success_calls }} last month
                    </p>
                  </div>
                  <div>
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-success-subtle rounded-circle fs-2">
                        <i class="ri-checkbox-circle-line text-success"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card card-animate card-height-100">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="fw-medium text-muted mb-0">Failed requests</p>
                    <h2 class="mt-4 ff-secondary fw-bold">
                      <span [countUp]="failed_calls" class="counter-value" [options]="option"></span>
                    </h2>
                    <p class="mb-0 text-muted">
                      <span class="badge bg-light mb-0" [ngClass]="percentageChange_failed_calls >= 0 ? 'text-success' : 'text-danger'">
                        <i class="align-middle" [ngClass]="percentageChange_failed_calls >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'"></i> {{ percentageChange_failed_calls }}% </span> {{ prev_failed_calls }} last month
                      </p>
                    </div>
                    <div>
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title bg-danger-subtle rounded-circle fs-2">
                          <i class="ri-spam-line text-danger"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" style="height: 350px;">
              @if (chart_data.length === 0) {
                <div class="text-center mt-sm-5 pt-4">
                  <div class="mb-5 text-white-50">
                    <p class="fs-14">There is not enough data for graph view.</p>
                  </div>
                </div>
              }
              @if (chart_data.length > 0) {
                <ngx-charts-bar-vertical-2d
                  [scheme]="colorScheme"
                  [results]="chart_data"
                  [gradient]="gradient"
                  [xAxis]="showXAxis"
                  [yAxis]="showYAxis"
                  [legend]="showLegend"
                  [showGridLines]="false"
                  [showXAxisLabel]="showXAxisLabel"
                  [showYAxisLabel]="showYAxisLabel"
                  [xAxisLabel]="xAxisLabel"
                  [yAxisLabel]="yAxisLabel">
                </ngx-charts-bar-vertical-2d>
              }
            </div>
          </div>
        }

        <ng-template #createAPIKey let-modal>
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
              <div class="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/hmqggwrl.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <h4>This will create an api key, once created you will get the key only once, keep it safe and don't share with anyone!</h4>
                </div>
              </div>
              <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
                <button type="button" class="btn w-sm btn-load btn-success" (click)="onSubmit()">
                  <span class="d-flex justify-content-center">
                    @if (submitted && spinner) {
                      <span class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </span>
                    }
                    <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Create</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #regenerateAPIKey let-modal>
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
              <div class="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/hmqggwrl.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
                <div class="alert alert-danger">
                  <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
                </div>
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <h4>Are you sure you want to regenerate the api key?</h4>
                </div>
              </div>
              <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
                <button type="button" class="btn w-sm btn-load btn-success" (click)="onSubmit()">
                  <span class="d-flex justify-content-center">
                    @if (submitted && spinner) {
                      <span class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </span>
                    }
                    <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Regenerate</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #successModal let-modal>
          <div class="modal-content">
            <div class="modal-body text-center p-5">
              <div class="text-end">
                <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
              </div>
              <div class="mt-2">
                <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
                <div class="alert alert-danger">
                  <p class="text-warning mt-2">** API key is only view once when created, copy it and save it in a safe place.</p>
                </div>
                <div class="input-group">
                  <input type="text" class="form-control" [value]="key_once" id="api-key" readonly>
                  <button class="btn btn-success shadow-none ri-clipboard-line" ngbTooltip="Copy key to clipboard" (click)="copyToClipboard()" type="button"></button>
                </div>
                <p class="text-danger mt-2">DO NOT SHARE WITH ANYONE!!!</p>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #errorModal let-modal>
          <div class="modal-content">
            <div class="modal-body text-center p-5">
              <div class="text-end">
                <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
              </div>
              <div class="mt-2">
                <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
                <h4 class="mb-3 mt-4">Something went wrong</h4>
                <p class="text-muted fs-15 mb-4">we were unable to create the key! please try again in a few minutes or contact support.</p>
              </div>
            </div>
          </div>
        </ng-template>